/**
 * Select component themable props.
 */
import { stringLiteralArray } from "../utils"

export default {
  appearances: stringLiteralArray(["default", "ghosted"]),
  subcomponents: stringLiteralArray([
    "control",
    "clearIndicator",
    "dropdownIndicator",
    "groupHeading",
    "indicatorSeparator",
    "input",
    "multiValueLabel",
    "multiValueRemove",
    "valueContainer"
  ])
}
